import {
  Switch,
  Route,
  useLocation,
  Redirect
} from "react-router-dom";
import Home from './pages/home/Home';
import InfringementChecker from './pages/infringement_checker/InfringementChecker';
import { useContext, useState } from 'react';
import { AuthContext } from '@zboxglobal/zboxauth';
import SignIn from './pages/sign_in/SignIn';
import Navbar from './components/navbar/Navbar';

interface IRoute {
  path: string;
  component: () => JSX.Element;
  displayName: string;
  exact: boolean;
  display: boolean;
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement> & {
    title?: string | undefined;
  }>;
}

export const _routes: IRoute[] = [
  { path: "/", component: Home, displayName: "Home", exact: true, display: false },
  { path: "/infringementchecker", component: InfringementChecker, displayName: "Infringement Checker", exact: true, display: true },
].sort((a, b) => a.displayName.localeCompare(b.displayName));

function App(props: { autoLoginPromise: Promise<void>; children?: JSX.Element | JSX.Element[] | null }) {
  var auth = useContext(AuthContext);
  const location = useLocation();

  const [loginDone, setLoginDone] = useState(auth.status.loggedIn);
  if (!loginDone) {
    props.autoLoginPromise.then(
      () => {
        setLoginDone(true);
      },
      () => {
        setLoginDone(true);
      }
    );

    return <div>Loading</div>;
  }

  return (
    <Switch>
      <Route>
        <>
          {props.children ? (
            props.children
          ) : auth.status.loggedIn ? (
            <>
              <div>
                <Navbar />
                <Switch>
                  {_routes.map((route, index) => {
                    return (
                      <Route
                        key={index}
                        path={route.path}
                        exact={route.exact}
                        children={<route.component />}
                      />
                    );
                  })}
                </Switch>
              </div>
            </>) : <Switch>
            <Route exact path={`/signin`} component={SignIn} />
            <Route>
              <Redirect
                to={{
                  pathname: `/signin`,
                  search: "?p=" + encodeURIComponent(location.pathname + location.search)
                }}
              />
            </Route>
          </Switch>}
        </>
      </Route>
      {/* {_routes.map((route, index) => {
        return (
          <Route
            key={index}
            path={route.path}
            exact={route.exact}
            children={<route.component />}
          />
        );
      })} */}
    </Switch>
  );
}

export default App;
